export default __webpack_public_path__ + "static/media/setting.fc5b0222.svg";